import DefaultPortrait from "slides/layouts/DefaultPortrait.react";
import DefaultLandscape from "slides/layouts/DefaultLandscape.react";
import GridLandscape from "slides/layouts/GridLandscape.react";

const layoutMap = {
    portrait: {
        default: DefaultPortrait,
        grid: DefaultPortrait,
    },
    landscape: {
        default: DefaultLandscape,
        grid: GridLandscape,
    },
};

const renderLayout = (isPortrait, layout) => {
    return isPortrait
        ? layout == null
            ? DefaultPortrait
            : layoutMap.portrait[layout]
        : layout == null
        ? GridLandscape
        : layoutMap.landscape[layout];
};

const ThemeSet = {};

export { ThemeSet, renderLayout };
